// import logo from 'assets/img/logo.svg';
// import 'assets/css/App.scss';

import Header from 'components/header';
import Download  from 'components/download';

function App() {
  return (
    <div className="App">
      <Header />
      <Download />
    </div>
  );
}

export default App;
